import type { IxcSweepsClearingV1SweepOrderKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const SWEEP_ORDER_BASE_PATH = getResolvedPath('/clearing/operations/sweep/order');

export const getSweepOrderPath: EntityPathBuilder<IxcSweepsClearingV1SweepOrderKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return SWEEP_ORDER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.sweepOrderId) {
        return undefined;
      }

      return getResolvedPath(`${SWEEP_ORDER_BASE_PATH}/$sweepOrderId`, context.keys);
    }
  }
};

export function getSweepOrderDetailPath(sweepOrderId: string | undefined) {
  if (!sweepOrderId) {
    return undefined;
  }

  return getSweepOrderPath({ kind: 'detail', keys: { sweepOrderId } });
}

